import { render, staticRenderFns } from "./sendMailForm.vue?vue&type=template&id=16aa9f2a"
import script from "./sendMailForm.vue?vue&type=script&lang=js"
export * from "./sendMailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports